export const useLicensedTerritory = (options = { raw: false }) => {
  const { licensedTerritory } = useRuntimeConfig().public
  return options.raw ? licensedTerritory : licensedTerritory.toLowerCase()
}
